export const checkPhoneNumber = (rule: any, value: any) => {
  const regExp = /^(\s+|[0-9])[0-9]+([0-9]|\s+)$/;
  if (!!value && !regExp.test(value) && value.trim() !== '') {
    return Promise.reject(new Error(`The format is not correct!`));
  } else if (
    !!value &&
    (value.length < 8 || value.length > 17) &&
    value.trim() !== ''
  ) {
    return Promise.reject(
      new Error(`Phone No. must be between 8-17 characters!`),
    );
  } else {
    return Promise.resolve();
  }
};

export const cardNumberCheck = (rule: any, value: any) => {
  const regExp = /^[A-Za-z0-9]+$/;
  if (!!value && !regExp.test(value) && value.trim() !== '') {
    return Promise.reject(new Error(`The format is not correct!`));
  } else {
    return Promise.resolve();
  }
};

export const checkEmail = (rule: any, value: any) => {
  const regExp =
    /^(\s+|[a-zA-Z0-9._-])+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+([a-zA-Z]|\s+)$/;
  if (!!value && !regExp.test(value) && value.trim() !== '') {
    return Promise.reject(new Error(`Email format is not correct!`));
  } else {
    return Promise.resolve();
  }
};

export const checkChassisNumberAndEngineNumber = (rule: any, value: string) => {
  const regExp = /^(?=.*[a-zA-Z])(?=.*\d).+$/;
  if (value && value !== '' && (!regExp.test(value) || value.length < 6)) {
    return Promise.reject(new Error(`The format is not correct!`));
  } else {
    return Promise.resolve();
  }
};

export const emailRegExp =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const characterNumber = /^[A-Za-z0-9]+$/;

export const reg =
  /^(?=.*[0-9])(?=.*[A-Z])(?=.*[a-z])(?=.*[~`!@#$%^&*()_\-+={[}\]\\|:;"'<,>.\\?\\/])[0-9a-zA-Z~`!@#$%^&*()_\-+={[}\]\\|:;"'<,>.\\?\\/]{8,30}$/;

export const bankStaffCodeReg = /^[a-zA-Z0-9]{1,20}$/;
export const payNumberReg = /^[0-9]{6}$/;
export const phoneNumberReg = /^0?([3-9][0-9]{8}|[1-2][0-9]{9})$/;
export const emailReg =
  /^(\s+|[a-zA-Z0-9._-])+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+([a-zA-Z]|\s+)$/;
export const referralReg = /^[a-zA-Z0-9]{8}$/;

export const nameReg = /^[^\d|~`!@#$%^&*()._\-+={[}\\/:;'"><?\]]*$/;

export const idNumberReg = /^[0-9]{9}([0-9]{3})?$/;
